import Vue from 'vue';
import NotificationCenterComponent from './components/NotificationCenter';

//external-plugin
import VueToast from 'vue-toast-notification';
import i18n from "@global/i18n";

Vue.config.devtools = true;
Vue.config.productionTip = false;

Vue.use(VueToast, {
  position: 'bottom-right',
  dismissible: true,
  duration: 20000,
});

let component = document.getElementById('js-notification-center-vue-entry');

class NotificationCenter {
  init() {
    this.startApp();
  }

  startApp() {
    new Vue({
      el: component,
      i18n,
      ...component.dataset,
      infoMsgs: JSON.parse(component.getAttribute('data-info-msgs')),
      errorMsgs: JSON.parse(component.getAttribute('data-error-msgs')),
      confMsgs: JSON.parse(component.getAttribute('data-conf-msgs')),
      render: h => h(NotificationCenterComponent),
    });
  }
}

export const notificationCenter = new NotificationCenter();



// WEBPACK FOOTER //
// ./src/global/notificationCenter/NotificationCenter.js